import React from 'react';

const Unauthorized = () => {
    return <h2>Unauthorized Access</h2>;
};

export default Unauthorized;
